import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Job from "./Job";
import { fetchJobs } from "../../features/job/jobSlice";
import Search from "./Search";

export default function JobBoard() {
  const dispatch = useDispatch();

  const { jobs, isError, isLoading } = useSelector((state) => state.jobs);

  const { type, sort, search } = useSelector((state) => state.filter);

  useEffect(() => {
    dispatch(fetchJobs());
  }, [dispatch]);

  const handleFilter = (job) => {
    switch (type) {
      case "Internship":
        return job.type === "Internship";
      case "Full Time":
        return job.type === "Full Time";
      case "Remote":
        return job.type === "Remote";
      default:
        return true;
    }
  };
  const handleSort = (a, b) => {
    if (sort === "asc") {
      return parseFloat(a.salary) - parseFloat(b.salary);
    }
    if (sort === "desc") {
      return parseFloat(b.salary) - parseFloat(a.salary);
    }
  };

  const handleSearch = (job) =>
    job.title.toUpperCase().includes(search.toUpperCase());

  // decide what to render
  let content = null;
  if (isLoading) content = <div>Loading...</div>;
  if (!isLoading && isError) content = <div>There was an error occured</div>;
  if (!isLoading && !isError && jobs?.length > 0) {
    content = jobs
      .filter(handleFilter)
      .filter(handleSearch)
      .sort(handleSort)
      .map((job) => <Job key={job.id} job={job} />);
  }
  if (!isLoading && !isError && jobs?.length === 0) {
    content = <div>No Job Available!</div>;
  }

  return (
    <main className="max-w-3xl rounded-lg  mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
      <div className="md:flex space-y-2 md:space-y-0 justify-between mb-10 ">
        <h1 className="lws-section-title">All Available Jobs</h1>
        <Search />
      </div>
      {content}
    </main>
  );
}
